'use client';

import Link from 'next/link';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';
import { categoryDisplayName } from '@utils/category-name';

export default function CrossLinks({ currentCategorySlug, categories, provinces, categoryName }) {
  const otherCategories = categories?.filter((c) => c.slug !== currentCategorySlug)?.slice(0, 8);
  const otherProvinces = provinces?.slice(0, 8);

  if (!otherCategories?.length && !otherProvinces?.length) return null;

  return (
    <div className="space-y-8">
      {otherProvinces?.length > 0 && (
        <section>
          <h2 className="text-lg font-bold text-[#1a1a1a] tracking-[-0.01em] mb-4">También buscar en</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {otherProvinces.map((p) => (
              <Link
                key={p.slug}
                href={`/${currentCategorySlug}/${p.slug}`}
                onClick={() =>
                  trackEvent(EVENTS.CATEGORY_CROSS_LINK_CLICKED, {
                    link_type: 'province',
                    category_slug: currentCategorySlug,
                    province: p.province,
                    vendor_count: p.count
                  })
                }
                className="group flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 bg-white/60 hover:border-gray-300 hover:-translate-y-0.5 transition-all duration-200"
              >
                <div>
                  <span className="text-[13px] font-semibold text-[#1a1a1a] group-hover:text-primary-600 transition-colors">
                    {categoryName} en {p.province}
                  </span>
                  <p className="text-[11px] text-gray-400 mt-0.5">
                    {Number(p.count).toLocaleString('es-AR')} negocio{p.count !== 1 ? 's' : ''}
                  </p>
                </div>
                <ArrowRightIcon className="w-3.5 h-3.5 text-gray-300 group-hover:text-primary-500 transition-all group-hover:translate-x-0.5" />
              </Link>
            ))}
          </div>
        </section>
      )}

      {otherCategories?.length > 0 && (
        <section>
          <h2 className="text-lg font-bold text-[#1a1a1a] tracking-[-0.01em] mb-4">Otras categorías</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {otherCategories.map((c) => (
              <Link
                key={c.slug}
                href={`/${c.slug}`}
                onClick={() =>
                  trackEvent(EVENTS.CATEGORY_CROSS_LINK_CLICKED, {
                    link_type: 'category',
                    category: c.keyword,
                    category_slug: c.slug,
                    vendor_count: c.count
                  })
                }
                className="group flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 bg-white/60 hover:border-gray-300 hover:-translate-y-0.5 transition-all duration-200"
              >
                <div>
                  <span className="text-[13px] font-semibold text-[#1a1a1a] group-hover:text-primary-600 transition-colors">
                    {categoryDisplayName(c.keyword)}
                  </span>
                  <p className="text-[11px] text-gray-400 mt-0.5">
                    {c.count.toLocaleString('es-AR')} negocio{c.count !== 1 ? 's' : ''}
                  </p>
                </div>
                <ArrowRightIcon className="w-3.5 h-3.5 text-gray-300 group-hover:text-primary-500 transition-all group-hover:translate-x-0.5" />
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
